import { render, staticRenderFns } from "./HealthKnowledge.vue?vue&type=template&id=d3edeb98&scoped=true&lang=html&"
import script from "./HealthKnowledge.vue?vue&type=script&lang=js&"
export * from "./HealthKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./HealthKnowledge.vue?vue&type=style&index=0&id=d3edeb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3edeb98",
  null
  
)

export default component.exports